import { render, staticRenderFns } from "./createcarbonfactor.vue?vue&type=template&id=7ca6714b&"
import script from "./createcarbonfactor.vue?vue&type=script&lang=ts&"
export * from "./createcarbonfactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createcarbonfactor.vue"
export default component.exports